const UNSAFE_PATH = /[\\\u0000-\u001f\u007f]|%(?:00|0a|0d|5c)/i;

/** Return a canonical HTTPS URL, or null for every other scheme/shape. */
export function safeHttpsUrl(raw: unknown): string | null {
  if (typeof raw !== 'string' || !raw || UNSAFE_PATH.test(raw)) return null;
  try {
    const parsed = new URL(raw);
    if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return null;
    return parsed.toString();
  } catch {
    return null;
  }
}

/**
 * Join a backend storefront path to a known HTTPS shop domain without
 * allowing a protocol-relative path to replace that domain.
 */
export function safeStorefrontUrl(domain: unknown, path: unknown): string | null {
  if (typeof domain !== 'string' || typeof path !== 'string') return null;
  if (!path.startsWith('/') || path.startsWith('//') || UNSAFE_PATH.test(path)) return null;
  const rawBase = domain.startsWith('https://') ? domain : `https://${domain}`;
  const safeBase = safeHttpsUrl(rawBase);
  if (!safeBase) return null;
  try {
    const base = new URL(safeBase);
    const joined = new URL(path, base);
    if (joined.origin !== base.origin) return null;
    return joined.toString();
  } catch {
    return null;
  }
}

/** Build a mailto target only from a plain, header-free email address. */
export function safeMailtoUrl(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.length > 254 || raw !== raw.trim()) return null;
  if (/[\\\u0000-\u0020\u007f?&#"'<>]/.test(raw)) return null;
  if (!/^[^@]+@[^@.]+(?:\.[^@.]+)+$/.test(raw)) return null;
  return `mailto:${raw}`;
}
